import React, { Component } from 'react';

export default class Filters extends Component {
  static propTypes = {};
  render() {
    return (<div>filters</div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js